<template>
    <div class="rich-text" v-loading="!isInit" v-if="isInit">
        <h3 class="edit-field-title">
            <div v-if="field.name" class="label-item">
                <p class="label-text">{{ field.desc }}</p>
                <el-tooltip class="item" effect="light" placement="bottom-start">
                    <div slot="content">
                        - name: <strong>{{ field.name }}</strong><br/>
                    </div>
                    <i class="label-icon el-icon-info"></i>
                </el-tooltip>
            </div>
        </h3>
        <div class="weixinaddress-input">
            <weixinCollectInput
                v-model="collection_address"
                @collect-res="collectResHandler"
            />
        </div>
        <ueEditor
            ref="ueEditorEle" 
            :name="field.name || randomNum" 
            @content-change="contentChangeHandler"
            @blur="contentChangeHandler"
            @init-complete="ueEditorInitHandler"></ueEditor>
    </div>
</template>
<script>
import moment from 'moment';
import { loadScript } from '../../service/requestApi.js';
import ueEditor from '../ueEditor.vue';
import weixinCollectInput from '../weixinCollectInput';

export default {
    name: 'rich-text',
    props: ['field', 'autoInit'],
    data() {
        return {
            ueditorEle: null,
            collection_address: '',
            isInit: false,
            randomNum: parseInt(Math.random()*1000).toString()
        }
    },
    components: {
        ueEditor,
        weixinCollectInput
    },
    methods: {
        initData() {
            this.isInit = true;
        },
        fieldBeReady() {
            // 确认组件是否就绪
            return this.$refs['ueEditorEle'];
        },
        getResField() {
            try {
                let htmlText = this.$refs['ueEditorEle'].getContent();
                this.field.def_val = htmlText;
            } catch(e) {
                console.log(`error,val: ${this.field.def_val}`);
                throw e;
            }
            return this.field;
        },
        contentChangeHandler(ct) {
            this.field.def_val = ct;
        },
        collectResHandler(val) {
            this.field.def_val = val;
            this.ueEditorInitHandler();
        },
        ueEditorInitHandler() {
            this.ueditorEle = this.$refs['ueEditorEle'];
            this.ueditorEle.setContent(this.field.def_val);
        }
    },
    computed: {
    },
    watch: {
        'field'(val) {
            this.ueditorEle && this.ueditorEle.setContent(val.def_val);
        }
    },
    created() {
        if(this.autoInit) {
            this.isInit = true;
        }
    },
    mounted() {

    }
}
</script>
<style lang="less">
    @import (reference) '../../styles/public.less';
    .rich-text {
        .label-item();
        // padding-bottom: 100px;
        .edit-field-title {
            font-size: 14px;
            margin-bottom: 5px;
        }
        .weixinaddress-input {
            height: 50px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/richTextForm.vue